import { cx } from '@emotion/css';

import { PhoenixImage } from '@phoenix/core/frontend/shared/ui/assets/phoenix-image';
import { containerQueries } from '@phoenix/design-system/frontend/ui/breakpoints/breakpoints';

export const PromotionalImage = ({ imageSrc = 'house-garden.jpeg', className }) => {
  const imageProps = {
    src: imageSrc,
    sizes: `(max-width: ${containerQueries.tablet}) 100vw, (max-width: ${containerQueries.desktop}) 50vw, 30vw`,
    staticTags: ['imagesDashboard'],
  };

  return (
    <div className={cx('relative aspect-[4/3] h-full w-full overflow-hidden rounded-lg border border-secondary-mid', className)}>
      <PhoenixImage layout="fill" objectFit="cover" {...imageProps} />
    </div>
  );
};
